import { Session, Command, Message, ExecutionLogEntry, SessionTemplate } from '@/types/console';

export const mockCommands: Command[] = [
  {
    id: 'search',
    name: '/search',
    description: 'Search across meetings, clients, and more',
    example: '/search client onboarding issues',
    displayName: 'Search',
  },
  {
    id: 'ic',
    name: '/ic',
    description: 'Load Intentionally Creative company context',
    example: '/ic create a brand strategy',
    displayName: 'Intentionally Creative',
  },
  {
    id: 'askalden',
    name: '/askalden',
    description: 'Ask Alden a strategic question',
    example: '/askalden what should our Q1 focus be?',
    displayName: 'Ask Alden',
  },
  {
    id: 'social',
    name: '/social',
    description: 'Generate social media content',
    example: '/social create 5 LinkedIn posts',
    displayName: 'Social Media',
  },
  {
    id: 'analyze',
    name: '/analyze',
    description: 'Analyze a call transcript or document',
    example: '/analyze summarize key insights',
    displayName: 'Analyze',
  },
  {
    id: 'strategy',
    name: '/strategy',
    description: 'Strategic planning and recommendations',
    example: '/strategy quarterly planning',
    displayName: 'Strategy',
  },
  {
    id: 'brand',
    name: '/brand',
    description: 'Apply brand tone and guidelines',
    example: '/brand review this copy',
    displayName: 'Brand',
  },
];

// Fallback mock templates (used if API unavailable)
// All mock templates are treated as global
export const mockTemplates: SessionTemplate[] = [
  {
    id: 'blank',
    name: 'Blank',
    description: 'Start with a clean slate',
    suggestedCommands: [],
    isGlobal: true,
  },
  {
    id: 'social-planning',
    name: 'Social Media Planning',
    description: 'Plan and create social content',
    suggestedCommands: ['social', 'brand', 'ic'],
    isGlobal: true,
  },
  {
    id: 'call-analysis',
    name: 'Call Analysis',
    description: 'Analyze and summarize calls',
    suggestedCommands: ['analyze', 'ic'],
    isGlobal: true,
  },
  {
    id: 'founder-question',
    name: 'Founder Question',
    description: 'Strategic guidance from Alden',
    suggestedCommands: ['askalden', 'ic'],
    isGlobal: true,
  },
  {
    id: 'client-strategy',
    name: 'Client Strategy',
    description: 'Develop client strategies',
    suggestedCommands: ['strategy', 'ic', 'brand'],
    isGlobal: true,
  },
];

// Empty initial state - no mock data
export const mockSessions: Session[] = [];

export const mockMessages: Message[] = [];

export const mockExecutionLog: ExecutionLogEntry[] = [];

export const helpContent = {
  title: 'How This Works',
  sections: [
    {
      title: 'What This System Can Do',
      items: [
        'Generate strategic content and plans',
        'Analyze calls, documents, and images',
        'Apply brand voice and guidelines automatically',
        'Create social media content calendars',
        'Provide founder-level strategic insights',
      ],
    },
    {
      title: 'What This System Cannot Do',
      items: [
        'Access external systems or databases directly',
        'Make purchases or financial transactions',
        'Send emails or messages on your behalf',
        'Access private company data not loaded in context',
      ],
    },
    {
      title: 'Available Commands',
      items: [
        '/ic — Load Intentionally Creative context',
        '/askalden — Ask strategic questions',
        '/social — Generate social media content',
        '/analyze — Analyze documents or calls',
        '/strategy — Strategic planning help',
        '/brand — Apply brand guidelines',
      ],
    },
    {
      title: 'Example Workflows',
      items: [
        '1. Load company context → Generate social plan',
        '2. Upload call transcript → Get key insights',
        '3. Ask strategic question → Get founder perspective',
        '4. Create content → Apply brand review',
      ],
    },
  ],
};
